export const DEFAULT_LESSON_REMINDERS = {
  enabled: true,
  channel: "email",
  firstLessonOnly: true,
  optedOutAt: null,
  lastSentAt: null,
};

export function buildDefaultNewClientNotifications() {
  return {
    sendNotifications: true,
    lessonReminders: { ...DEFAULT_LESSON_REMINDERS },
  };
}

export function normalizeLessonRemindersForForm(lessonReminders = {}, options = {}) {
  const defaultEnabled = typeof options.defaultEnabled === "boolean" ? options.defaultEnabled : false;
  return {
    ...DEFAULT_LESSON_REMINDERS,
    ...lessonReminders,
    channel: lessonReminders.channel || "email",
    enabled: typeof lessonReminders.enabled === "boolean" ? lessonReminders.enabled : defaultEnabled,
    firstLessonOnly: typeof lessonReminders.firstLessonOnly === "boolean" ? lessonReminders.firstLessonOnly : true,
    optedOutAt: lessonReminders.optedOutAt || null,
    lastSentAt: lessonReminders.lastSentAt || null,
  };
}

export function updateLessonReminderPreference(client, field, value) {
  const lessonReminders = normalizeLessonRemindersForForm(client.lessonReminders, { defaultEnabled: !client.id });
  if (field === "preference") {
    return {
      ...client,
      lessonReminders: {
        ...lessonReminders,
        enabled: value !== "none",
        firstLessonOnly: value !== "all",
      },
    };
  }

  return {
    ...client,
    lessonReminders: {
      ...lessonReminders,
      [field]: value,
    },
  };
}
